export let BASE_URL = "http://192.168.1.46/labtest/elite-api-wizard/v1/";
export let BASE_URL_IMG = "http://192.168.1.46/";

let DEVELPMENT_MODE = 4
if (DEVELPMENT_MODE === 2) {
    // BASE_URL = "http://192.168.1.35/labtest/elite-api-wizard/v1/";
    // BASE_URL_IMG = "http://192.168.1.35/";
    BASE_URL = "http://192.168.1.57/labtest/elite-api-wizard/v1/";
    BASE_URL_IMG = "http://192.168.1.57/";
}

if (DEVELPMENT_MODE === 3) {
    BASE_URL = "https://api.wizardfootball.com/v1/";
    BASE_URL_IMG = "https://img.wizardfootball.com/";
}

if (DEVELPMENT_MODE === 4) {
    BASE_URL = "https://apitest.wizardfootball.com/v1/";
    BASE_URL_IMG = "https://img.wizardfootball.com/";
}

export const LOGIN_END_POINT = `${BASE_URL}login.2step`;
export const ACCOUNT_END_POINT = `${BASE_URL}account`;
export const CLUBS_END_POINT = `${BASE_URL}clubs.platform`;
export const TEAMS_END_POINT = `${BASE_URL}teams.platform`;